import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterKollerhube() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-kollerhube-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-kollerhube-heading">WETTER</h1>
        </div>

        <Wetter ort="kollerhube" />
      </div>
    </div>
  );
}

export default WetterKollerhube;
